import { COUNTRIES } from "../data/content";

const CONTINENTS = [
  "M85,80 L160,58 L250,62 L300,95 L310,135 L280,150 L250,185 L215,175 L185,145 L130,140 L95,115 Z",
  "M255,215 L300,205 L330,240 L325,300 L295,360 L275,355 L260,290 L250,245 Z",
  "M455,60 L520,55 L575,70 L580,105 L555,130 L520,150 L480,140 L465,105 Z",
  "M480,160 L545,150 L580,190 L590,240 L560,300 L530,320 L505,275 L485,215 Z",
  "M585,60 L720,50 L850,70 L900,110 L880,160 L800,190 L740,215 L700,180 L640,150 L595,110 Z",
  "M770,225 L800,235 L790,265 L765,260 Z",
  "M830,285 L900,280 L925,325 L890,360 L840,345 L820,315 Z",
];

export const WorldMap = () => (
  <svg viewBox="0 0 1000 420" className="w-full h-auto" role="img" aria-label="World map highlighting the regions BHF Creative serves">
    <defs>
      <radialGradient id="dotGlow">
        <stop offset="0%" stopColor="#00D9C0" stopOpacity="0.9" />
        <stop offset="100%" stopColor="#00D9C0" stopOpacity="0" />
      </radialGradient>
    </defs>
    {CONTINENTS.map((d, i) => (
      <path key={i} d={d} fill="rgba(108,92,231,0.06)" stroke="rgba(160,163,194,0.28)" strokeWidth="1.2" strokeLinejoin="round" />
    ))}
    {COUNTRIES.map((c) => (
      <g key={c.name}>
        <circle cx={c.x} cy={c.y - 40} r="14" fill="url(#dotGlow)" />
        <circle cx={c.x} cy={c.y - 40} r="3.5" fill="#00D9C0">
          <title>{c.name}</title>
        </circle>
      </g>
    ))}
  </svg>
);
